module.exports = __webpack_public_path__ + "media/images/3-quart-8f2e349d962833a2a01ea26304c9b912.png";